export default __webpack_public_path__ + "media/images/mailer/logo-9cecc1bd64697ec7b413c03f1c0540e4.png";